'use strict';

angular.module('docketbook').
  controller('acceptOrderWizardModalController', function (addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, docketService) {
    $scope.formComplete = false;
    $scope.allTemplates = [];
    $scope.itemEdit = {};
    $scope.ignoredLineItems = [];
    $scope.templateAccordionOpen = true;
    $scope.noTemplates = false;


    $scope.$parent.showAcceptOrderWizard = function () {
      $scope.formComplete = false;
      $scope.allTemplates = [];
      $scope.ignoredLineItems = [];
      // link local item edit to parent item edit.  All changes made will be reflected on both.
      $scope.itemEdit = $scope.$parent.itemEdit;

      $("#templateArea").css({ 'max-height': '' })

      if ($scope.itemEdit.template != null) {
        $scope.templateAccordionOpen = false;
        minimiseAccordion()
      } else {
        $scope.templateAccordionOpen = true;
      }
      $scope.loadTemplateList();
      checkFormComplete();

      $("#acceptOrderWizardModal").fadeIn(100);
    }

    var checkFormComplete = function () {
      $scope.formComplete = false;
      $scope.noTemplates = false;

      if ($scope.itemEdit.template == null) {
        return;
      }

      for (var i = 0; i < $scope.itemEdit.lineItems.length; i++) {
        var lineItem = $scope.itemEdit.lineItems[i];
        if (!lineItem.resource && !$scope.ignoredLineItems.includes(lineItem.id)) {
          return;
        }
      }

      $scope.formComplete = true;
    }

    $scope.editTemplate = function () {
      $scope.templateAccordionOpen = true;
      var height = document.getElementById('templateArea').scrollHeight //$("#templateArea").scrollHeight()
      $("#templateArea").animate({ 'max-height': height + 'px' }, 200)
      $('#templateSubHead').animate({ opacity: 1 }, 200)
    }

    $scope.close = function () {
      $scope.$parent.cancelEditOrder($scope.itemEdit);
      $("#acceptOrderWizardModal").fadeOut(100);
    }

    $scope.acceptOrder = function () {
      if (!$scope.formComplete || $scope.itemEdit.loading) {
        return;
      }
      $("#acceptOrderWizardModal").fadeOut(100);
      $scope.$parent.acceptOrder($scope.itemEdit, function () { }, function () {
        // error
        $("#acceptOrderWizardModal").fadeIn(100);
      })
    }

    var minimiseAccordion = function () {
      var height = document.getElementById('templateArea').scrollHeight
      $("#templateArea").css({ 'max-height': height + 'px' })
      $("#templateArea").animate({ 'max-height': '85px' }, 200)
      $('#templateSubHead').animate({ opacity: 0 }, 200)
    }

    $scope.assignTemplate = function (template) {
      if (template != null) {
        if (template == $scope.itemEdit.template) {
          minimiseAccordion();
        } else {

          // get full docket template
          docketService.getTemplate(template, function (fullTemplate) {
            $scope.$parent.assignTemplate(fullTemplate, function () {
              $scope.templateAccordionOpen = false;
              checkFormComplete();
              minimiseAccordion()
            })
          }, function (err) {
            $scope.itemEdit.template = null;
            $scope.showToast('Error Loading Docket Template');
            checkFormComplete();
          });
        }
      }
    }

    $scope.selectResourceForLine = function (lineItem) {
      $scope.$parent.selectResourceForLine(lineItem, function () {
        checkFormComplete();
      });
    }

    $scope.loadTemplateList = function () {
      $scope.promise = $q(function (resolve, reject) {
        // Get templates from docketService
        docketService.getTemplates({ "published": "true" }, function (templates) {
          $scope.allTemplates = templates;

          // Display help message if there are no templates
          $scope.noTemplates = $scope.allTemplates.length == 0

          // Auto select template if there is only 1
          if ($scope.allTemplates.length == 1) {
            $scope.assignTemplate($scope.allTemplates[0]);
          }
          resolve('Done');
        }, function (error) {
          $scope.allTemplates = [];
          reject('Error');
        });
      });
    }

    $scope.goToCreateDocketTemplates = function () {
      $state.go('companySettings.templates', { orgId: $scope.currentOrg.id })
    }

    $scope.ignoreLineItem = function (lineItem) {
      lineItem.resource = null;
      if (!$scope.ignoredLineItems.includes(lineItem.id)) {
        $scope.ignoredLineItems.push(lineItem.id);
      }
      checkFormComplete();
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/modals/acceptOrderWizardModalController.js